import type { IModuleDefinition, IRecordTypeDefinition } from '@platform/core/types';
import { childModuleType } from '@platform/engine/menu/childModuleType';
import { mainRecordTypeOf } from '@platform/engine/menu/moduleSections';

/**
 * Тип записів, форму якого редагує «Форма» (прототип v4 formMod): дочірня таблиця з `?type=` (окремий модуль прототипу: «Видатки»,
 * «Декларації»), інакше основний тип модуля; без типів — undefined. Чиста функція.
 */
export function formRecordType(module: IModuleDefinition, typeKey: string | null | undefined): IRecordTypeDefinition | undefined {
  return childModuleType(module, typeKey) ?? mainRecordTypeOf(module);
}
